import React from 'react';
import { connect } from 'react-redux';
import { XCircle } from 'react-feather'
import '../../assets/styles/components/dropdown.scss';
import { openDropdown } from '@/actions/app';
import { Icons } from '@/configurations';
import classnames from 'classnames'

class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this)
    this.state = {
      isOpen: false,
      internalOptions: [],
      searchOptions: [],
      selectedOptions: props.selectedOptions,
      searchKeyword: '',
      chosenIndex: -1,
      position: {}
    }
    this.dropdownContainer = React.createRef();
    this.searchInput = React.createRef();
  }

  renderSingle() {
    const { language, placeholder, textCenter } = this.props;
    const { selectedOptions, internalOptions } = this.state;

    const prefix = selectedOptions[0] ? selectedOptions[0] && selectedOptions[0].prefix : ''
    const label = selectedOptions[0]
    ? language[selectedOptions[0].label]
      ? language[selectedOptions[0].label]
      : selectedOptions[0].label
    : internalOptions.length > 0
    ? placeholder
    : ''

    return (
      <span className={classnames('dropdown-option-single-selected', textCenter && 'dropdown-text-center')} title={[prefix, label].join('')}>
        {prefix}
        {label}
      </span>
    )
  }

  renderMultiple() {
    const { isOpen, selectedOptions, internalOptions } = this.state;
    return (
      <div>
        {selectedOptions.length > 0 ? (
          selectedOptions.map((o, index) => {
            return (
              <div key={o.value} className='dropdown-option-selected'>
                <span title={[o.prefix, o.label].join('')}>
                  {o.prefix}
                  {o.label}
                </span>
                <span onClick={event => this.removeOption(event, index)} className='icon is-small icon-close'>
                  <XCircle />
                </span>
              </div>
            )
          })
        ) : (
          <span className='dropdown-option-single-selected'>{'\u00A0'}</span>
        )}
        {selectedOptions.length < internalOptions.length && isOpen && (
          <input ref={this.searchInput} className='dropdown-search' type='text' onChange={this.handleSearchOption} onClick={this.handleClickSearchInput} />
        )}
      </div>
    )
  }

  render() {
    const { isMultiple, style, disable } = this.props;
    const { isOpen } = this.state;

    return (
      <button
        className={classnames('dropdown-container', isOpen && 'dropdown-input-focus', disable && 'dropdown-input-disable')}
        ref={this.dropdownContainer}
        style={style}
        onFocus={this.toggleMenuOption}
      >
        <div className={classnames('dropdown-input')} onClick={this.toggleMenuOption}>
          {isMultiple ? this.renderMultiple() : this.renderSingle()}
          <div className={classnames('icon is-small icon-chevron', isOpen && 'arrow-up')}>{<Icons.ArrowDown size={16} />}</div>
        </div>
        {/* <div className={classnames('dropdown-content', isOpen ? 'dropdown-content-open' : undefined)}>
          {internalOptions.map((o, index) => {
            return (
              <div className={classnames('dropdown-option', index === chosenIndex ?
                'dropdown-option-chosen' : undefined)}
                style={{
                  display: o.isVisible && o.label.toLowerCase().includes(searchKeyword) ?
                    'block' : 'none'
                }}
                key={o.value}
                onMouseEnter={() => this.handleMouseEnter(index)}
                onClick={() => this.handleChooseOption(index)}>
                <p>{o.prefix}{language[o.label] ? language[o.label] : o.label}</p>
              </div>
            )
          })}
        </div> */}
      </button>
    )
  }

  handleClickSearchInput = (e) => {
    if (this.state.isOpen) {
      e.stopPropagation();
    }
  }

  toggleMenuOption = () => {
    if(this.props.disable){
      return
    }
    this.setState({ isOpen: !this.state.isOpen, chosenIndex: -1 }, () => {
      if (this.props.isMultiple && this.state.isOpen && this.searchInput.current) {
        this.setState({ searchKeyword: '' })
        this.searchInput.current.focus();
      }
      this.computePosition();
    })
  }

  handleSearchOption = (e) => {
    const text = e.currentTarget.value;
    this.setState({ searchKeyword: text.toLowerCase() })
  }

  removeOption(event, index) {
    event.stopPropagation()
    document.removeEventListener('click', this.handleClick)
    const { options } = this.props;
    let newSelectedOption = [...this.state.selectedOptions];
    let newInternalOptions = [...this.state.internalOptions];
    const removeOption = newSelectedOption.splice(index, 1);
    const rebornOptionIndex = options.findIndex(o => o.value === removeOption[0].value);
    if (rebornOptionIndex > -1) {
      newInternalOptions[rebornOptionIndex].isVisible = true;
    }
    this.setState({ selectedOptions: newSelectedOption, internalOptions: newInternalOptions }, () => {
      document.addEventListener('click', this.handleClick)
    })
    this.props.onChange(newSelectedOption)
  }

  handleChooseOption(index) {
    let isChange = true;
    const { options } = this.props;
    let newInternalOptions = [...this.state.internalOptions];
    let newSelectedOption = [...this.state.selectedOptions];
    if (this.props.isMultiple) {
      newSelectedOption.push(options[index])
      newInternalOptions[index].isVisible = false;
      this.setState({
        isOpen: newSelectedOption.length !== options.length,
        internalOptions: newInternalOptions,
        selectedOptions: newSelectedOption
      })
    } else {
      newInternalOptions[index].isVisible = false;
      if (newSelectedOption.length > 0) {
        const rebornOptionIndex = options.findIndex(o => o.value === newSelectedOption[0].value);
        if (rebornOptionIndex > -1) {
          newInternalOptions[rebornOptionIndex].isVisible = true;
        }
      }
      newSelectedOption = [options[index]]
      isChange = newSelectedOption[0].value !== this.state.selectedOptions[0]?.value
      this.setState({ isOpen: false, internalOptions: newInternalOptions, selectedOptions: [options[index]] })
    }
    isChange && this.props.onChange(newSelectedOption)
  }

  handleClick = (e) => {
    if (this.dropdownContainer && !this.dropdownContainer.current.contains(e.target) && this.state.isOpen) {
      this.setState({ isOpen: false })
    }
  }

  handleMouseEnter(index) {
    this.setState({ chosenIndex: index })
  }

  onKeyDown = e => {
    if (this.searchInput.current) {
      const { internalOptions, chosenIndex, searchKeyword } = this.state;
      switch (e.keyCode) {
        case 13: {
          this.handleChooseOption(chosenIndex)
          return;
        }
        case 27: {
          this.setState({ isOpen: false })
          return;
        }
        case 38: {
          for (let i = 1; i < internalOptions.length; i++) {
            let tmpIndex = (chosenIndex - i) % internalOptions.length;
            if (tmpIndex < 0) {
              tmpIndex += internalOptions.length
            }
            if (internalOptions[tmpIndex].isVisible &&
                internalOptions[tmpIndex].label.toLowerCase().includes(searchKeyword)) {
              this.setState({ chosenIndex: tmpIndex });
              break;
            }
          }
          return;
        }
        case 40: {
          for (let i = 1; i < internalOptions.length; i++) {
            let tmpIndex = (chosenIndex + i) % internalOptions.length;
            if (internalOptions[tmpIndex].isVisible &&
                internalOptions[tmpIndex].label.toLowerCase().includes(searchKeyword)) {
              this.setState({ chosenIndex: tmpIndex });
              break;
            }
          }
          return;
        }
        default:
          return;
      }
    }
  }

  setValue(v = []) {
    // debugger
    if (Array.isArray(v)) {
      let newInternalOptions = [...this.props.options];
      newInternalOptions.map(o => {
        const findIndex = v.findIndex(i => i?.value === o.value);
        o.isVisible = findIndex === -1;
        return o;
      })
      this.setState({ selectedOptions: v, internalOptions: newInternalOptions })
    }
  }

  getValue() {
    return this.state.selectedOptions;
  }

  initData() {
    const { options, isMultiple, selectedOptions } = this.props;
    if (options.length > 0) {
      const internalOptions = options.reduce((acc, o) => {
        let newOption = {
          ...o,
          isVisible: true
        }
        if (!isMultiple && selectedOptions.length > 0 && selectedOptions[0]?.value === newOption.value) {
          newOption.isVisible = false;
        }
        acc.push(newOption);
        return acc;
      }, [])
      // this.setState({ internalOptions, selectedOptions: isMultiple ? [] : [options[0]] })
      this.setState({ internalOptions, selectedOptions });
    }
    // document.addEventListener('click', this.handleClick)
    // document.addEventListener('keydown', this.onKeyDown)
  }

  computePosition = () => {
    const {DropdownStyle} = this.props
    const pos = this.dropdownContainer.current.getBoundingClientRect();
    this.setState({
      position: {
        top: pos.top,
        left: pos.left,
        width: pos.width,
        height: pos.height
      }
    }, () => {
      openDropdown(this.state.internalOptions, this.state.position, this.props.textCenter, this.props.defaultTheme, (index) => {
        this.setState({ isOpen: !this.state.isOpen })
        if (index !== '') {
          this.handleChooseOption(index)
        }
      },DropdownStyle);
    })
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.options) !== JSON.stringify(this.props.options)) {
      this.initData();
    }
  }

  componentDidMount() {
    this.initData();
  }

  componentWillUnmount() {
    // document.removeEventListener('click', this.handleClick)
    // document.removeEventListener('keydown', this.onKeyDown)
  }
}

Dropdown.defaultProps = {
  options: [],
  selectedOptions: [],
  isMultiple: false,
  innerRef: () => {
  },
  onChange: () => {
  },
  style: {
    height: 23
  },
  placeholder: '--',
  prefix: '',
  disable:false,
  textCenter: null,
}

export default connect(
    state => ({
      language: state.app.language
    })
)(Dropdown)
